import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import SpellsList from "./components/SpellsList";
import SpellDetails from "./components/SpellDetails";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SpellsList />} />
        <Route path="/spell/:index" element={<SpellDetails />} />
      </Routes>
    </Router>
  );
}

export default App;
